'use client'
// src/components/NewsletterForm.tsx
import { useState } from 'react'
// we will get subscribeSuccess, subscribeError and alreadySubscribed from the props
const NewsletterForm = ({
  subscribeSuccess,
  subscribeError,
  alreadySubscribed,
}: {
  subscribeSuccess: string
  subscribeError: string
  alreadySubscribed: string
}) => {
  const [email, setEmail] = useState('')
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle')
  const [message, setMessage] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setStatus('loading')

    try {
      const tokenResponse = await fetch('/api/newsletter-proxy/oauth/v2/token', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Basic ${process.env.NEXT_PUBLIC_NEWSLETTER2GO_AUTH_TOKEN}`,
        },
        body: JSON.stringify({
          username: process.env.NEXT_PUBLIC_NEWSLETTER2GO_USERNAME,
          password: process.env.NEXT_PUBLIC_NEWSLETTER2GO_PASSWORD,
          grant_type: 'https://nl2go.com/jwt',
        }),
      })

      const tokenData = await tokenResponse.json()

      if (!tokenResponse.ok || !tokenData.access_token) {
        throw new Error(tokenData.error_description || 'Failed to get access token')
      }

      const subscribeResponse = await fetch('/api/newsletter-proxy/recipients', {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${tokenData.access_token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          phone: null,
          gender: null,
          first_name: null,
          last_name: null,
          is_unsubscribed: false,
          is_blacklisted: false,
        }),
      })

      if (subscribeResponse.ok) {
        setMessage(subscribeSuccess)
        setStatus('success')
        setEmail('')
        return
      }

      const errorData = await subscribeResponse.json()

      if (
        subscribeResponse.status === 409 ||
        errorData?.error === 'duplicate_entry' ||
        errorData?.error_description?.toLowerCase().includes('duplicate')
      ) {
        setMessage(alreadySubscribed)
        setStatus('error')
        return
      }

      throw new Error(errorData?.error_description || 'Subscription failed')
    } catch (error) {
      setMessage(subscribeError)
      setStatus('error')
    }
  }

  return (
    <div className="news__letter">
      <h6 className="news__letter__heading">Newsletter</h6>
      <form className="news-letter__form" onSubmit={handleSubmit}>
        <input
          type="email"
          id="email"
          name="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          disabled={status === 'loading'}
          className={status === 'loading' ? 'disabled' : ''}
        />
        <button
          className={`subscribe ${status === 'loading' ? 'disabled' : ''}`}
          type="submit"
          disabled={status === 'loading'}
        >
          {status === 'loading' ? '...' : 'Subscribe'}
        </button>
      </form>
      {message && <div className={`newsletter-message ${status}`}>{message}</div>}
    </div>
  )
}

export default NewsletterForm
